import { z } from "zod";

export const CreateOrganizationFormSchema = z.object({
  name: z.string().min(1, "Name is required"),
  industry: z.string().min(1, "Industry is required"),
  type: z.string().min(1, "Type is required"),
});

export type CreateOrganizationFormValues = z.infer<
  typeof CreateOrganizationFormSchema
>;

export const defaultCreateOrganizationFormValues: CreateOrganizationFormValues =
  {
    name: "",
    industry: "",
    type: "business",
  };
